import { SUPPORT_EMAIL } from "@/constants";
import { env } from "@/env";
import type { ModalProps } from "@/ui";
import { Modal } from "@/ui";

export const HelpModal = ({ closeModal, isOpen }: ModalProps) => {
  return (
    <Modal closeModal={closeModal} isOpen={isOpen}>
      <div className="flex size-full flex-col justify-center gap-5 rounded-card bg-surface px-6 py-10 sm:px-10 md:px-14 md:py-14">
        <p className="text-2xl leading-tight font-bold sm:text-3xl">We’re here.</p>

        <p className="text-lg leading-normal font-semibold text-content md:text-xl">
          Have questions or prefer to talk with an EO rep?
        </p>

        <ul className="flex list-disc flex-col gap-4 pl-5">
          <li>
            <p className="text-sm md:text-lg">
              Browse our{" "}
              <a
                className="underline decoration-1 underline-offset-8"
                href={`${env.VITE_MARKETING_SITE_DOMAIN}/web/frequently-asked-questions`}
                rel="noopener noreferrer"
                target="_blank"
              >
                FAQs
              </a>
            </p>
          </li>

          <li>
            <div className="flex items-center gap-2">
              <p className="text-sm md:text-lg">
                Email{" "}
                <a
                  className="underline decoration-1 underline-offset-8"
                  href={`mailto:${SUPPORT_EMAIL}`}
                >
                  {SUPPORT_EMAIL}
                </a>
              </p>
              <div className="rounded-full bg-accent-surface px-2.5 py-1 text-sm font-semibold text-accent">
                Fastest reply
              </div>
            </div>
          </li>

          <li>
            <div className="flex items-center gap-2">
              <p className="text-sm md:text-lg">
                Call{" "}
                <a
                  className="underline decoration-1 underline-offset-8"
                  href={`tel:${env.VITE_EO_CONTACT_NUMBER.replace(/[^\d+]/g, "")}`}
                >
                  {env.VITE_EO_CONTACT_NUMBER}
                </a>
              </p>
              <p className="text-sm font-semibold text-content-muted">Mon–Fri, 9am–5pm ET</p>
            </div>
          </li>
        </ul>
      </div>
    </Modal>
  );
};
